import NoteComment from '~/scripts/services/model/note-comment';

/**
 * @typedef {Object} NodeLink
 * @property {import('@knitiv/api-client-javascript').KNode} [class_kid]
 * @property {import('@knitiv/api-client-javascript').KNode} kid
 * @property {import('@knitiv/api-client-javascript').LinkerKNode} [linker_kid]
 * @property {string} [name]
 */

/**
 * @class NoteContext
 */
export default class NoteContext {
	/**
	 * @param {*} value
	 * @throws {Error}
	 * @returns {void}
	 */
	static set isa(value) {
		throw new Error(`The isa property cannot be written. ${value} was passed.`);
	}

	/**
	 * @param {any} noteContext
	 */
	constructor(noteContext = null) {
		/** @type {NodeLink[]} */
		this.affectedTo = noteContext?.affectedTo ?? [];

		/** @type {{ created: Date, updated: ?Date}} */
		this.date = {
			created: noteContext?.date?.created ? new Date(noteContext.date.created) : new Date(),
			updated: noteContext?.date?.updated ? new Date(noteContext.date.updated) : null,
		};

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = noteContext?.kid;

		/** @type {'K_NODE;KNOTECTX'} */
		this.isa = 'K_NODE;KNOTECTX';

		/** @type {NodeLink[]} */
		this.linkto = noteContext?.linkto ?? [];

		/** @type {import('./note-comment').default[]} */
		this.notes = noteContext?.notes.map((/** @type {any} */ note) => new NoteComment(note)) ?? [];

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.owner = noteContext?.owner?.kid ?? noteContext?.owner;

		/** @type {NodeLink[]} */
		this.participants = noteContext?.participants ?? [];

		/** @type {{create: boolean, update: boolean, delete: boolean}} */
		this.rights = noteContext?.rights ?? {
			create: true,
			update: true,
			delete: true,
		};

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.type = noteContext?.type?.kid ?? noteContext?.type;
	}

	/**
	 * @param {import('./note-comment').default} note
	 */
	addNote(note) {
		this.notes.push(note);
	}

	export() {
		return {
			author:       this.owner,
			date:         this.date,
			kid:          this.kid,
			linkto:       this.linkto,
			participants: this.participants,
		};
	}

	getParticipants() {
		return this.participants.map(p => p.name).join('<br>');
	}
}
